import * as contentful from 'contentful';

import type { ClientParameters } from '../types/client';

export function createClient({
    spaceId,
    deliveryAccessToken,
    previewAccessToken,
    environmentId,
    previewMode,
}: ClientParameters) {
    if (!spaceId.value) {
        throw new Error(`
            ERROR: The environment variable "${spaceId.envVarKey}" is not set in
            the .env file located at the root of the project.
    
            This variable is essential to the Contentful Library. Please set
            it appropriately or disable the Contentful Library.
    
            More info at: https://www.contentful.com/help/find-space-id/
        `);
    }

    if (!deliveryAccessToken.value) {
        throw new Error(`
            ERROR: The environment variable "${deliveryAccessToken.envVarKey}" is
            not set in the .env file located at the root of the project.
    
            This variable is essential to the Contentful Library. Please set
            it appropriately or disable the Contentful Library.
    
            More info at: https://www.contentful.com/developers/docs/references/content-delivery-api
        `);
    }

    if (!previewAccessToken.value) {
        throw new Error(`
            ERROR: The environment variable "${previewAccessToken.envVarKey}" is
            not set in the .env file located at the root of the project.
    
            Without this variable set, the Contentful Preview API will not work.
    
            More info at: https://www.contentful.com/developers/docs/references/content-preview-api/
        `);
    }

    if (!environmentId.value) {
        console.warn(`
            WARN: The environment variable "${environmentId.envVarKey}" is not set,
            defaulting to the "master" environment.
        `);
    }

    if (!previewMode.value) {
        console.warn(`
            WARN: The environment variable "${previewMode.envVarKey}" is not set,
            defaulting to the "false" value.
        `);
    }

    const parameters = {
        space: spaceId.value,
        ...(environmentId.value && { environment: environmentId.value }),
    };

    let client;
    if (previewMode.value === 'true') {
        client = contentful.createClient({
            ...parameters,
            accessToken: previewAccessToken.value,
            host: 'preview.contentful.com',
        });
    } else {
        client = contentful.createClient({
            ...parameters,
            accessToken: deliveryAccessToken.value,
        });
    }
    return client;
}
